import { Route, Routes } from "react-router-dom";
import Login from "./components/SignIn/Login";
import React from "react";
import PrivateRoute from 'components/routing/PrivateRoute';
import Dashboard from "./components/Dashboard/Dashboard";
import DoctorList from "./components/ManageDoctors/Doctorlist";
import DoctorProfile from "./components/ManageDoctors/DoctorProfile";
import RegisteredDoctorsList from "./components/RegisteredDoctors/RegisteredDoctorsList";
import DoctorsRequest from "./components/DoctorsRequest/Doctorlist";
import PatientList from "./components/ManagePatients/Patientslist";
import DrugList from "./components/ManageDrugs/DrugsList";
import PatientHistoryMaster from "./components/PatientHistoryMaster/PatientHistoryMaster";
import HospitalList from "./components/Hospital/MedicalFacultyList";
import 'i18n/i18n';
import HospitalDoctors from "./components/Hospital/hospitalDoctors";
import Settings from "./components/Settings/Settings";
import TemplateList from "./components/Templates/TemplateList";
import Modal from "react-modal";
import AddTemplate from "./components/Templates/AddTemplate";
import EditTemplate from "./components/Templates/EditTemplate";
import PmjayList from "./components/ManagePmjay/PmjayList";
import ReportTemplateList from "./components/ReportTemplates/ReportTemplateList";
import MethodMasterList from "./components/LabMasters/MethodMasterList";
import ExternalLabList from "./components/ExternalLabs/ExternalLabList";
import CalculationMasterList from "./components/LabMasters/CalculationMasterList";
import CghsRateList from "./components/ManageCghsRates/CghsRateList";
import DentalMasterList from "./components/DentalMaster/DentalMasterList";
import ImmunizationMasters from "./components/ManageImmunization/ImmunizationMasters";
import EclinicDoctors from "./components/E-Clinics/EclinicDoctors";
import EclinicDoctorDetails from "./components/E-Clinics/EclinicDoctorDetails";
import AbdmBridge from "./components/AbdmBridge/AbdmBridge";
import ConsentList from "./components/Consent/ConsentList";
import ConsentBuilder from "./components/Consent/ConsentBuilder";

Modal.setAppElement("#root");

function App() {
  return (
    <div style={{ background: "#FBFBFB", zIndex: 2 }}>
      <Routes>
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/addtemplate" element={<AddTemplate />} />
        <Route exact path="/edittemplate/:id" element={<EditTemplate />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        >
          <Route index element={<DoctorList />} />
          <Route index path="/doctors" element={<DoctorList />} />
          <Route exact path="doctors/:id" element={<DoctorProfile />} />
          <Route
            exact
            path="registered-doctors"
            element={<RegisteredDoctorsList />}
          />
          <Route exact path="patients" element={<PatientList />} />
          <Route exact path="drugs" element={<DrugList />} />
          <Route
            exact
            path="patient-history-master"
            element={<PatientHistoryMaster />}
          />
          <Route exact path="settings" element={<Settings />} />
          <Route exact path="template" element={<TemplateList />} />
          <Route exact path="medicalFaculty" element={<HospitalList />} />
          <Route
            exact
            path="medicalFaculty/doctors"
            element={<HospitalDoctors />}
          />
          <Route index exact path="request" element={<DoctorsRequest />} />
          <Route exact path="pmjay" element={<PmjayList />} />
          <Route
            exact
            path="report-template"
            element={<ReportTemplateList />}
          />
          <Route
            exact
            path="lab-method-master"
            element={<MethodMasterList />}
          />
          <Route
            exact
            path="lab-calculation-master"
            element={<CalculationMasterList />}
          />
          <Route exact path="external-labs" element={<ExternalLabList />} />
          <Route exact path="cghs-rates" element={<CghsRateList />} />{" "}
          <Route exact path="dental-master" element={<DentalMasterList />} />
          <Route
            exact
            path="immunization-master"
            element={<ImmunizationMasters />}
          />
          <Route exact path="consent" element={<ConsentList />} />
          <Route exact path="consent/:id" element={<ConsentBuilder />} />
          <Route exact path="eclinic" element={<EclinicDoctors />} />
          <Route exact path="eclinic/:id" element={<EclinicDoctorDetails />} />
          <Route exact path="abdm-bridge" element={<AbdmBridge />} />

        </Route>
      </Routes>
    </div>
  );
}

export default App;
